export enum EDealTypes {
  Any = 'any',
  Rent = 'rent',
  BuyOrSale = 'sale',
}
